import React, { useState, useCallback } from 'react'
import PropTypes from 'prop-types'
import FileManagementModal from './FileManagementModal'

const FileUploadButton = ({
  resourceId,
  resourceName,
  ensembleId,
  ensembleName,
  fileVariables,
  uploadedCount,
  totalCount
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleClick = useCallback(event => {
    event.preventDefault()
    event.stopPropagation()
    setIsModalOpen(true)
  }, [])

  const handleCloseModal = useCallback(() => {
    setIsModalOpen(false)
  }, [])

  const allFilesUploaded = uploadedCount === totalCount

  return (
    <>
      <a
        href="#"
        className="file-upload-trigger"
        title={allFilesUploaded ? 'Tous les fichiers sont importés' : 'Fichiers manquants'}
        onClick={handleClick}
      >
        <i className="fas fa-upload mr-1" />
        {uploadedCount}
        /
        {totalCount}
      </a>
      <FileManagementModal
        resourceId={resourceId}
        resourceName={resourceName}
        ensembleId={ensembleId}
        ensembleName={ensembleName}
        fileVariables={fileVariables}
        isOpen={isModalOpen}
        onClose={handleCloseModal}
      />
    </>
  )
}

FileUploadButton.propTypes = {
  ensembleId: PropTypes.number.isRequired,
  ensembleName: PropTypes.string.isRequired,
  fileVariables: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      variableType: PropTypes.string.isRequired
    })
  ).isRequired,
  resourceId: PropTypes.number.isRequired,
  resourceName: PropTypes.string.isRequired,
  totalCount: PropTypes.number.isRequired,
  uploadedCount: PropTypes.number.isRequired
}

export default FileUploadButton